import React, {FC} from 'react'
import {Row,Col, Select} from 'antd'
import classnames from 'classnames'

import StylesType from '@/types/StylesType'
import './style/SelectForm.less'
import {LabeledValue} from "antd/lib/select";

type SelectValue = string | string
export interface SelectFormTypes<T = SelectValue> {
  title?:T;
  selectValue?: string|string[]|number|number[]|LabeledValue|LabeledValue[]
  dataSource?: any[];
  value?: T;
  lable?: T;
  onChange?: (value?: any, option?: any) => void;
}


type SelectFormPorps = Partial<StylesType & SelectFormTypes<SelectValue>>

const SelectForm: FC<SelectFormPorps> = props =>{
  const {prefixCls='gc_select_form', className, title, dataSource=[], value='value', lable='lable', onChange, selectValue} = props
  return (
    <>
      <Row className={classnames(prefixCls, className)} type={'flex'} align='middle' gutter={[12, 0]}>
        <Col>{title}</Col>
        <Col>
          <Select className={classnames(prefixCls+'_package_input')} onChange={onChange} value={selectValue}>
            {dataSource.map((data, index) => {
              return <Select.Option value={data[value]} key={index}>{data[lable]}</Select.Option>
            })}
          </Select>
        </Col>
      </Row>
    </>
  )
}

export default SelectForm
